import * as Types from '../../generated/graphql.types';

import gql from 'graphql-tag';
import { SpotForRoutingFragmentDoc } from '../_shared/fragments.generated';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FetchCourseQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type FetchCourseQuery = { __typename?: 'QueryRoot', course: { __typename?: 'Course', id: string, name: string, isVisibleToAllUserGroups: boolean, userGroupId: string, spots: Array<{ __typename?: 'Spot', id: string, assetId: number, courseId: string, spotType: Types.SpotType, name?: string | null, description?: string | null, order: number, parentSpotId?: string | null, note?: string | null, hasMusic: boolean, coordinate: { __typename?: 'Coordinate', lat: number, lon: number } }>, routeChangeAlert?: { __typename?: 'RouteChangeAlert', courseId: string, archiveFilePath: string, createdAt: string, route: Array<{ __typename?: 'Coordinate', lon: number, lat: number }> } | null }, appConfig: { __typename?: 'AppConfig', routeChangeAlert: boolean } };

export type RoutingInfomationQueryVariables = Types.Exact<{
  courseId: Types.Scalars['String'];
}>;


export type RoutingInfomationQuery = { __typename?: 'QueryRoot', routingInfomation: { __typename?: 'RoutingInfomationPayload', error?: string | null, routingInfomation?: { __typename?: 'RoutingInfomation', from: { __typename?: 'Coordinate', lon: number, lat: number }, to: { __typename?: 'Coordinate', lon: number, lat: number }, route: Array<{ __typename?: 'Coordinate', lon: number, lat: number }>, navigation: Array<{ __typename?: 'NavigationVoiceAndCoordinate', navigationVoice: string, coordinate: { __typename?: 'Coordinate', lon: number, lat: number } }>, spotStat: Array<{ __typename?: 'SpotStat', statsAfterSpotId: string, durationDistance: { __typename?: 'DurationDistance', duration: number, distance: number } }> } | null, routingInfomationWithoutOpt?: { __typename?: 'RoutingInfomation', from: { __typename?: 'Coordinate', lon: number, lat: number }, to: { __typename?: 'Coordinate', lon: number, lat: number }, route: Array<{ __typename?: 'Coordinate', lon: number, lat: number }>, navigation: Array<{ __typename?: 'NavigationVoiceAndCoordinate', navigationVoice: string, coordinate: { __typename?: 'Coordinate', lon: number, lat: number } }>, spotStat: Array<{ __typename?: 'SpotStat', statsAfterSpotId: string, durationDistance: { __typename?: 'DurationDistance', duration: number, distance: number } }> } | null } };

export type TrialDriveQueryVariables = Types.Exact<{
  trialDriveId: Types.Scalars['String'];
}>;


export type TrialDriveQuery = { __typename?: 'QueryRoot', trialDrive: { __typename?: 'TrialDrive', trialDriveId: string, name: string, createdAt: string, userId: string, userGroupId: string, spots: Array<{ __typename?: 'TrialDriveSpot', trialDriveSpotId: string, name: string, latitude: number, longitude: number, memo: string, order: number, hasRestaurant: boolean, hasCafe: boolean, hasRestroom: boolean, hasPaidParking: boolean, hasFreeParking: boolean, trialDriveSpotPhotos: Array<{ __typename?: 'TrialDriveSpotPhoto', trialDriveSpotPhotoId: string, url: string }> }>, passingPointSegments: Array<Array<{ __typename?: 'TrialDrivePassingPoint', trialDrivePassingPointId: string, order: number, latitude: number, longitude: number }>> } };

export type TrialDriveFragment = { __typename?: 'TrialDrive', trialDriveId: string, name: string, createdAt: string, userId: string, userGroupId: string, spots: Array<{ __typename?: 'TrialDriveSpot', trialDriveSpotId: string, name: string, latitude: number, longitude: number, memo: string, order: number, hasRestaurant: boolean, hasCafe: boolean, hasRestroom: boolean, hasPaidParking: boolean, hasFreeParking: boolean, trialDriveSpotPhotos: Array<{ __typename?: 'TrialDriveSpotPhoto', trialDriveSpotPhotoId: string, url: string }> }>, passingPointSegments: Array<Array<{ __typename?: 'TrialDrivePassingPoint', trialDrivePassingPointId: string, order: number, latitude: number, longitude: number }>> };

export type TrialDriveSpotFragment = { __typename?: 'TrialDriveSpot', trialDriveSpotId: string, name: string, latitude: number, longitude: number, memo: string, order: number, hasRestaurant: boolean, hasCafe: boolean, hasRestroom: boolean, hasPaidParking: boolean, hasFreeParking: boolean, trialDriveSpotPhotos: Array<{ __typename?: 'TrialDriveSpotPhoto', trialDriveSpotPhotoId: string, url: string }> };

export type TrialDriveSpotPhotoFragment = { __typename?: 'TrialDriveSpotPhoto', trialDriveSpotPhotoId: string, url: string };

export type TrialDrivePassingPointFragment = { __typename?: 'TrialDrivePassingPoint', trialDrivePassingPointId: string, order: number, latitude: number, longitude: number };

export const TrialDriveSpotPhotoFragmentDoc = gql`
    fragment TrialDriveSpotPhoto on TrialDriveSpotPhoto {
  trialDriveSpotPhotoId
  url
}
    `;
export const TrialDriveSpotFragmentDoc = gql`
    fragment TrialDriveSpot on TrialDriveSpot {
  trialDriveSpotId
  name
  latitude
  longitude
  memo
  order
  hasRestaurant
  hasCafe
  hasRestroom
  hasPaidParking
  hasFreeParking
  trialDriveSpotPhotos {
    ...TrialDriveSpotPhoto
  }
}
    ${TrialDriveSpotPhotoFragmentDoc}`;
export const TrialDrivePassingPointFragmentDoc = gql`
    fragment TrialDrivePassingPoint on TrialDrivePassingPoint {
  trialDrivePassingPointId
  order
  latitude
  longitude
}
    `;
export const TrialDriveFragmentDoc = gql`
    fragment TrialDrive on TrialDrive {
  trialDriveId
  name
  createdAt
  userId
  userGroupId
  spots {
    ...TrialDriveSpot
  }
  passingPointSegments {
    ...TrialDrivePassingPoint
  }
}
    ${TrialDriveSpotFragmentDoc}
${TrialDrivePassingPointFragmentDoc}`;
export const FetchCourseDocument = gql`
    query FetchCourse($id: String!) {
  course(id: $id) {
    id
    name
    spots {
      ...SpotForRouting
    }
    isVisibleToAllUserGroups
    userGroupId
    routeChangeAlert {
      courseId
      archiveFilePath
      createdAt
      route {
        lon
        lat
      }
    }
  }
  appConfig {
    routeChangeAlert
  }
}
    ${SpotForRoutingFragmentDoc}`;

export function useFetchCourseQuery(options: Omit<Urql.UseQueryArgs<FetchCourseQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchCourseQuery, FetchCourseQueryVariables>({ query: FetchCourseDocument, ...options });
};
export const RoutingInfomationDocument = gql`
    query RoutingInfomation($courseId: String!) {
  routingInfomation(courseId: $courseId) {
    routingInfomation {
      from {
        lon
        lat
      }
      to {
        lon
        lat
      }
      route {
        lon
        lat
      }
      navigation {
        coordinate {
          lon
          lat
        }
        navigationVoice
      }
      spotStat {
        statsAfterSpotId
        durationDistance {
          duration
          distance
        }
      }
    }
    routingInfomationWithoutOpt {
      from {
        lon
        lat
      }
      to {
        lon
        lat
      }
      route {
        lon
        lat
      }
      navigation {
        coordinate {
          lon
          lat
        }
        navigationVoice
      }
      spotStat {
        statsAfterSpotId
        durationDistance {
          duration
          distance
        }
      }
    }
    error
  }
}
    `;

export function useRoutingInfomationQuery(options: Omit<Urql.UseQueryArgs<RoutingInfomationQueryVariables>, 'query'>) {
  return Urql.useQuery<RoutingInfomationQuery, RoutingInfomationQueryVariables>({ query: RoutingInfomationDocument, ...options });
};
export const TrialDriveDocument = gql`
    query TrialDrive($trialDriveId: String!) {
  trialDrive(trialDriveId: $trialDriveId) {
    ...TrialDrive
  }
}
    ${TrialDriveFragmentDoc}`;

export function useTrialDriveQuery(options: Omit<Urql.UseQueryArgs<TrialDriveQueryVariables>, 'query'>) {
  return Urql.useQuery<TrialDriveQuery, TrialDriveQueryVariables>({ query: TrialDriveDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFetchCourseQuery((req, res, ctx) => {
 *   const { id } = req.variables;
 *   return res(
 *     ctx.data({ course, appConfig })
 *   )
 * })
 */
export const mockFetchCourseQuery = (resolver: ResponseResolver<GraphQLRequest<FetchCourseQueryVariables>, GraphQLContext<FetchCourseQuery>, any>) =>
  graphql.query<FetchCourseQuery, FetchCourseQueryVariables>(
    'FetchCourse',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRoutingInfomationQuery((req, res, ctx) => {
 *   const { courseId } = req.variables;
 *   return res(
 *     ctx.data({ routingInfomation })
 *   )
 * })
 */
export const mockRoutingInfomationQuery = (resolver: ResponseResolver<GraphQLRequest<RoutingInfomationQueryVariables>, GraphQLContext<RoutingInfomationQuery>, any>) =>
  graphql.query<RoutingInfomationQuery, RoutingInfomationQueryVariables>(
    'RoutingInfomation',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrialDriveQuery((req, res, ctx) => {
 *   const { trialDriveId } = req.variables;
 *   return res(
 *     ctx.data({ trialDrive })
 *   )
 * })
 */
export const mockTrialDriveQuery = (resolver: ResponseResolver<GraphQLRequest<TrialDriveQueryVariables>, GraphQLContext<TrialDriveQuery>, any>) =>
  graphql.query<TrialDriveQuery, TrialDriveQueryVariables>(
    'TrialDrive',
    resolver
  )
